<template>
    <div>
        <div :class="['popup_st21', 'w300']">
            <div :class="['popup_wrap']">
                <div class="title"><span class="t01">{{ facilityInfo.val1 }}</span>&nbsp;<span :class="[isPharManage(facilityInfo) == '영업중' ? 't_blue':'t_red']">{{ isPharManage(facilityInfo) }}</span></div>

                <div class="text3 t_red">
                    <span>※ 방문 전 해당 의료기관의 실제 운영여부를 꼭 확인하시기 바랍니다.</span>
                </div>
                <!-- <div class="text">
                    <span class="pop_bt_state t_red">{{facilityInfo.facItemNm}}</span>
                </div> -->

                <div class="pop_table03 ft10">
                    <table>
                        <colgroup>
                            <col style="width: 30%;">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>대표전화</th>
                                <td>{{ facilityInfo.val3 }}</td>
                            </tr>
                            <tr>
                                <th>주소</th>
                                <td>{{ facilityInfo.val2 }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="pop_table02">
                    <table>
                        <caption></caption>
                        <colgroup>
                            <col style="width: 20%;">
                            <col style="width: 30%;">
                            <col style="width: 20%;">
                            <col style="width: 30%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>요일</th>
                                <th>운영시간</th>
                                <th>요일</th>
                                <th>운영시간</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>월요일</th>
                                <td>
                                    <template v-if="!!facilityInfo.val5">
                                        {{ setColons(facilityInfo.val5) }} ~ {{ setColons(facilityInfo.val6) }}
                                    </template>
                                </td>
                                <th>화요일</th>
                                <td>
                                    <template v-if="!!facilityInfo.val7">
                                        {{ setColons(facilityInfo.val7) }} ~ {{ setColons(facilityInfo.val8) }}
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <th>수요일</th>
                                <td>
                                    <template v-if="!!facilityInfo.val9">
                                        {{ setColons(facilityInfo.val9) }} ~ {{ setColons(facilityInfo.val10) }}
                                    </template>
                                </td>
                                <th>목요일</th>
                                <td>
                                    <template v-if="!!facilityInfo.val11">
                                        {{ setColons(facilityInfo.val11) }} ~ {{ setColons(facilityInfo.val12) }}
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <th>금요일</th>
                                <td>
                                    <template v-if="!!facilityInfo.val13">
                                        {{ setColons(facilityInfo.val13) }} ~ {{ setColons(facilityInfo.val14) }}
                                    </template>
                                </td>
                                <th>토요일</th>
                                <td>
                                    <template v-if="!!facilityInfo.val15">
                                        {{ setColons(facilityInfo.val15) }} ~ {{ setColons(facilityInfo.val16) }}
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <th>일요일</th>
                                <td>
                                    <template v-if="!!facilityInfo.val17">
                                        {{ setColons(facilityInfo.val17) }} ~ {{ setColons(facilityInfo.val18) }}
                                    </template>
                                </td>
                                <th>공휴일</th>
                                <td>
                                    <template v-if="!!facilityInfo.val19">
                                        {{ setColons(facilityInfo.val19) }} ~ {{ setColons(facilityInfo.val20) }}
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="pop_bt_close2"><a href="javascript: void(0);" class="self-close-btn">닫기</a></div>
            </div>
        </div>
    </div>
</template>

<script>
import commonApi from "@/apis/common.api";
import { mapGetters } from "vuex";
import { $_TYPE, $_WC } from "@/confs/common.const.js";

export default {
    data() {
        return {
            facilityInfo: {},
        };
    },
    computed: {
        ...mapGetters({
            selectedHpCate: 'getSelectedHpCate',
        }),
    },
    updated() {
        this.$emit('loaded-facility-info', this.$el.innerHTML);
    },
    methods: {
        setFacilityInfo(facilityInfo, facilityCols) {
            this.facilityInfo = Object.assign({}, facilityInfo);
        },
        isPharManage(fac) {
            let fromNm = '';
            let toNm = '';

            let date = new Date();
            let day = date.getDay();
            let nowTime = date.getHours();
            nowTime = Number(nowTime + '00');
            let returnVal = '';
            switch (day) {
                case 1:
                    fromNm = 'val5'; toNm = 'val6';
                    break;
                case 2:
                    fromNm = 'val7'; toNm = 'val8';
                    break;
                case 3:
                    fromNm = 'val9'; toNm = 'val10';
                    break;
                case 4:
                    fromNm = 'val11'; toNm = 'val12';
                    break;
                case 5:
                    fromNm = 'val13'; toNm = 'val14';
                    break;
                case 6:
                    fromNm = 'val15'; toNm = 'val16';
                    break;
                case 7:
                    fromNm = 'val17'; toNm = 'val18';
                    break;
                default:
                    fromNm = ''; toNm = '';
                    break;
            }
            if(!!fac[fromNm] && !!fac[toNm]) {
                if(Number(fac[fromNm]) <= nowTime && nowTime <= fac[toNm]) {
                    returnVal = '영업중';
                } else {
                    returnVal = '휴무';
                }
            } else {
                returnVal = '휴무';
            }
            return returnVal;
        },
        setColons(txtVal) {
            let returnVal = '';
            if(!!txtVal) {
                returnVal = txtVal.substring(0, 2) + ':' + txtVal.substring(2, 4);
            }
            return returnVal
        },
    },
};
</script>
<style>
.pop_table03.nopd th{
    padding-top: 0px;
    padding-bottom: 0px;
}
.pop_table03.nopd td{
    padding-top: 0px;
    padding-bottom: 0px;
}
</style>
